import React, { Component } from 'react';

import { navigateTo } from '../utils/navigation';
import { weekdayLabel, formatStartTime, formatEventDateTime } from '../utils/seriesApi';

// Grilla de series del club (FR-001, FR-002, FR-011). Presentacional: los datos y el
// guardado los maneja SeriesPage, que es quien también abre el form.
//
// ⚠️ Cada fila mezcla los dos casings del contrato y hay que respetarlos: las COLUMNAS llegan
// en snake_case (`branch_id`, `start_time`, `poster_url`, `active`, `notes`) y sólo lo
// CALCULADO en camelCase (`eventCount`, `nextEvent`). Leer `serie.startTime`
// o `serie.nextevent` deja la celda vacía sin ningún error.
class TableSeriesComponent extends Component {

    // "Próxima jornada": la primera con fecha de hoy o posterior. Una serie con historial pero
    // sin nada agendado NO es lo mismo que una serie recién creada, y el texto lo dice: la
    // primera necesita "Nueva jornada", la segunda su primera jornada.
    renderProxima = (serie) => {
        const next = serie.nextEvent;
        if (!next) {
            return Number(serie.eventCount) > 0
                ? <span className="text-muted">Sin próxima jornada</span>
                : <span className="text-muted">Sin jornadas</span>;
        }
        return (
            <>
                <div>{formatEventDateTime(next.startsAt)}</div>
                <small className="text-muted">
                    {next.sold}{next.capacity != null ? `/${next.capacity}` : ''} vendidas
                </small>
                {next.full && (
                    <span className="badge badge-warning ml-2" title="No quedan lugares: sumá cupo desde la jornada">
                        Cupo completo
                    </span>
                )}
            </>
        );
    }

    renderFila = (serie, index) => {
        const activa = !!serie.active;
        return (
            <tr role="row" key={serie.id} style={{ background: index % 2 === 0 ? '#ffffff' : '#fcfcfc' }}>
                <td className="text-left">
                    <div>
                        {serie.name}
                        {serie.visibility === 'private' && (
                            <span className="badge badge-secondary ml-2" title="No se lista en la web">Privada</span>
                        )}
                    </div>
                    <small className="text-muted">{this.props.branchName(serie.branch_id)}</small>
                </td>
                <td>{weekdayLabel(serie.weekday)} {formatStartTime(serie.start_time)}</td>
                <td className="text-left">{this.renderProxima(serie)}</td>
                <td>{serie.eventCount}</td>
                <td>
                    <span className={`badge ${activa ? 'badge-success' : 'badge-secondary'}`}>
                        {activa ? 'Activa' : 'Inactiva'}
                    </span>
                </td>
                <td className="text-right text-nowrap">
                    <button type="button" className="btn btn-sm btn-white" onClick={() => navigateTo(`/series/${serie.id}`)}>
                        Ver jornadas
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary ml-2" onClick={() => this.props.onEdit(serie)}>
                        Editar
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-secondary ml-2"
                        disabled={this.props.disabled}
                        title={activa ? 'Deja de ofrecer "Nueva jornada"; el historial se conserva' : 'Vuelve a ofrecer "Nueva jornada"'}
                        onClick={() => this.props.onToggleActive(serie)}>
                        {activa ? 'Inactivar' : 'Activar'}
                    </button>
                </td>
            </tr>
        );
    }

    renderCuerpo() {
        if (this.props.loading) {
            return (<tr><td colSpan="7" className="text-center" style={{ padding: 30 }}>Cargando…</td></tr>);
        }
        if (this.props.error) {
            return (<tr><td colSpan="7" className="text-center" style={{ padding: 30, color: '#C4183C' }}>{this.props.error}</td></tr>);
        }
        const series = this.props.series || [];
        if (!series.length) {
            return (
                <tr><td colSpan="7" className="text-center" style={{ padding: 30, color: '#818EA3' }}>
                    {this.props.filtrando
                        ? 'No hay series con ese filtro.'
                        : 'Todavía no hay series. Creá la primera con el botón de arriba: la serie es la plantilla de la jornada que se repite todas las semanas.'}
                </td></tr>
            );
        }
        return series.map(this.renderFila);
    }

    render() {
        return (
            <div className="dataTables_wrapper no-footer">
                <table className="transaction-history dataTable no-footer dtr-inline" role="grid">
                    <thead>
                        <tr role="row">
                            <th className="text-left" style={{ width: '26%' }}>Serie</th>
                            <th style={{ width: '14%' }}>Día y hora</th>
                            <th className="text-left" style={{ width: '26%' }}>Próxima jornada</th>
                            <th style={{ width: '10%' }}>Jornadas</th>
                            <th style={{ width: '9%' }}>Estado</th>
                            <th style={{ width: '15%' }}></th>
                        </tr>
                    </thead>
                    <tbody>{this.renderCuerpo()}</tbody>
                </table>
            </div>
        );
    }
}

export default TableSeriesComponent;
